import React from 'react';

import Dialog from 'components/common/Dialog';

interface ErrorModalProps {
  isOpen: boolean;
  title?: string;
  message?: string;
  onCancel?: (() => void) | null;
  onRetry?: (() => void) | null;
  positiveCTA?: string | null;
  negativeCTA?: string | null;
}

const ErrorModal = ({
  isOpen,
  title = '',
  message = '',
  onCancel = null,
  onRetry = null,
  positiveCTA = null,
  negativeCTA = null,
}: ErrorModalProps) => (
  <Dialog
    isOpen={isOpen}
    title={title}
    message={message}
    positiveCTA={positiveCTA || 'Retry'}
    onPositive={onRetry}
    negativeCTA={negativeCTA || 'Cancel'}
    onNegative={onCancel}
    // We allow for injection here since all of our
    // error messaging is local (for now)
    injectHtml
  />
);

export default ErrorModal;
